import styled from 'styled-components';
import { colors, fontSizes, fonts, device } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';

export const SearchContacts = styled(TextField)`
  width: 100% !important;
  input {
    color: ${colors.black};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const ClientsContactSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .client-dropdown-search input {
    min-height: 38px;
    width: 100%;
    border-radius: 4px;
    &:focus,
    &:active {
      outline: none;
      border: none;
    }
  }
  .form-container {
    overflow: auto;
    height: 500px;
    overflow-y: scroll;
  }
  .client-name-box {
    height: 37px;
    background-color: ${colors.whiteSmoke};
    padding: 8px;
    strong {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .select-all-client {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }
  .share-contacts-container {
    display: grid;
    list-style-type: none;
    input[type='radio'] {
      &:focus {
        outline: none;
      }
    }
  }
  .list-contact {
    color: ${colors.zambezi};
    font-family: ${fonts.roboto};
    font-size: 13px;
    letter-spacing: 0;
    line-height: 25px;
    padding-right: 40px;
    display: flex;
  }
  .share-list-contact {
    width: 205px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .contact-box-container {
    box-sizing: border-box;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    overflow: auto;
    .search-contacts-container {
      height: 36px;
      border-radius: 4px 4px 0 0;
      background-color: ${colors.whiteSmoke};
    }
  }
  .search-contacts-form {
    width: 100%;
    .form__form-group-field {
      border: none;
      &:focus,
      &:active {
        border: none;
      }
    }
  }
  .selected-contacts-info {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 7px;
    font-family: MTTMilano;
  }
  .selected-contacts-quantity {
    border: 0 solid black;
    border-radius: 10px;
    height: 17px;
    width: 30px;
    color: ${colors.ghostWhite};
    font-weight: 900;
    line-height: 16px;
    text-align: center;
  }

  @media ${device.sm} {
    .share-contacts-container {
      grid-template-columns: repeat(1, max-content);
    }
  }

  @media ${device.md} {
    .share-contacts-container {
      grid-template-columns: repeat(2, max-content);
    }
  }

  @media ${device.lg} {
    .share-contacts-container {
      grid-template-columns: repeat(3, max-content);
    }
  }
`;
